import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { lastValueFrom } from 'rxjs';
import { IState } from 'appRedux/createStore';
import { ICasinoSchema } from 'appRedux/models/casinoModels';
import { CasinoService } from 'services/casino';
import { CASINO_OPTION_PREFIX, SettingOption } from './settingsOptions';

const slotCheckCasinoId = parseInt(__SLOTCHECK_ID__);

let cachedCasinos: ICasinoSchema[] | null = null;

// Opening Casino choices: the casinos the user can enter, same rules as the casino picker.
export const useCasinoOptions = (): SettingOption[] => {
  const [casinos, setCasinos] = useState<ICasinoSchema[]>(cachedCasinos ?? []);
  const isCasinoAccount = useSelector<IState>(
    (s) => s.app.persistedState.userInfo?.isCasinoAccount
  ) as boolean | undefined;

  useEffect(() => {
    if (cachedCasinos) return;
    let isMounted = true;
    lastValueFrom(new CasinoService().GetAllCasinos())
      .then((response) => {
        cachedCasinos = response?.DataSet ?? [];
        if (isMounted) setCasinos(cachedCasinos);
      })
      .catch(() => undefined);
    return () => {
      isMounted = false;
    };
  }, []);

  return casinos
    .filter(
      (casino) =>
        casino.casinoId !== slotCheckCasinoId &&
        casino.isactive &&
        (isCasinoAccount || !casino.isComingSoon)
    )
    .map((casino) => ({
      value: `${CASINO_OPTION_PREFIX}${casino.casinoId}`,
      label: casino.displayName,
      shortLabel: casino.shortName || casino.displayName,
    }));
};
